import { render, staticRenderFns } from "./ModuleSlim.vue?vue&type=template&id=972e7ea8&scoped=true&"
import script from "./ModuleSlim.vue?vue&type=script&lang=js&"
export * from "./ModuleSlim.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSlim.vue?vue&type=style&index=0&id=972e7ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e7ea8",
  null
  
)

export default component.exports